
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/balances/nfts",
      function () {
        return require("private-next-pages/balances/nfts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/balances/nfts"])
      });
    }
  